module.exports = __webpack_public_path__ + "media/views/builder/sites/assets/spinner-1074a4f3d41d4602952e10599beb319b.svg";